import React, { useState } from "react";
import classes from "../styles/blogRelatedEvent.module.css";
import { Typography } from "@mui/material";
import Diya from "../../../public/assets/blog/diya.svg";
import RelatedPujaItem from "./relatedPujaItem";
function BlogRelatedEventCard({
  data
}) {
  const [godName, setGodName] = useState(data.length > 0 ? data[0].PujaGodImage?.PujaGod?.name : "");
  return <>
      {data.length > 0 && <div className={classes.relatedEventContainer}>
          <div className={classes.relatedEventHeader}>
            <Diya />
            <Typography className={classes.headerText}>
              Offer Puja to {godName}
            </Typography>
            <Diya />
          </div>
          {data?.map((event, index) => <RelatedPujaItem key={index} index={index} data={event} />)}
        </div>}
    </>;
}
export default BlogRelatedEventCard;